// faIcons.ts
// Lista parcial de íconos gratuitos (Solid) de Font Awesome 6.x

export const FA_ICONS = [
    { label: "Address Book", iconClass: "fas fa-address-book" },
    { label: "Address Card", iconClass: "fas fa-address-card" },
    { label: "Angry", iconClass: "fas fa-angry" },
    { label: "Arrow Down", iconClass: "fas fa-arrow-down" },
    { label: "Arrow Left", iconClass: "fas fa-arrow-left" },
    { label: "Arrow Right", iconClass: "fas fa-arrow-right" },
    { label: "Arrow Up", iconClass: "fas fa-arrow-up" },
    { label: "Baby", iconClass: "fas fa-baby" },
    { label: "Balance Scale", iconClass: "fas fa-balance-scale" },
    { label: "Ban", iconClass: "fas fa-ban" },
    { label: "Battery Full", iconClass: "fas fa-battery-full" },
    { label: "Bell", iconClass: "fas fa-bell" },
    { label: "Bicycle", iconClass: "fas fa-bicycle" },
    { label: "Book", iconClass: "fas fa-book" },
    { label: "Bookmark", iconClass: "fas fa-bookmark" },
    { label: "Box", iconClass: "fas fa-box" },
    { label: "Briefcase", iconClass: "fas fa-briefcase" },
    { label: "Calendar", iconClass: "fas fa-calendar" },
    { label: "Camera", iconClass: "fas fa-camera" },
    { label: "Car", iconClass: "fas fa-car" },
    { label: "Chart Bar", iconClass: "fas fa-chart-bar" },
    { label: "Chart Line", iconClass: "fas fa-chart-line" },
    { label: "Check", iconClass: "fas fa-check" },
    { label: "Chevron Down", iconClass: "fas fa-chevron-down" },
    { label: "Chevron Left", iconClass: "fas fa-chevron-left" },
    { label: "Chevron Right", iconClass: "fas fa-chevron-right" },
    { label: "Chevron Up", iconClass: "fas fa-chevron-up" },
    { label: "Cogs", iconClass: "fas fa-cogs" },
    { label: "Coffee", iconClass: "fas fa-coffee" },
    { label: "Cog", iconClass: "fas fa-cog" },
    { label: "Columns", iconClass: "fas fa-columns" },
    { label: "Compass", iconClass: "fas fa-compass" },
    { label: "Copy", iconClass: "fas fa-copy" },
    { label: "Database", iconClass: "fas fa-database" },
    { label: "Edit", iconClass: "fas fa-edit" },
    { label: "Envelope", iconClass: "fas fa-envelope" },
    { label: "Exclamation Circle", iconClass: "fas fa-exclamation-circle" },
    { label: "Exclamation Triangle", iconClass: "fas fa-exclamation-triangle" },
    { label: "Eye", iconClass: "fas fa-eye" },
    { label: "Eye Slash", iconClass: "fas fa-eye-slash" },
    { label: "File", iconClass: "fas fa-file" },
    { label: "Film", iconClass: "fas fa-film" },
    { label: "Filter", iconClass: "fas fa-filter" },
    { label: "Flag", iconClass: "fas fa-flag" },
    { label: "Folder", iconClass: "fas fa-folder" },
    { label: "Folder Open", iconClass: "fas fa-folder-open" },
    { label: "Gas Pump", iconClass: "fas fa-gas-pump" },
    { label: "Globe", iconClass: "fas fa-globe" },
    { label: "Home", iconClass: "fas fa-home" },
    { label: "Info Circle", iconClass: "fas fa-info-circle" },
    { label: "Key", iconClass: "fas fa-key" },
    { label: "Lock", iconClass: "fas fa-lock" },
    { label: "Lock Open", iconClass: "fas fa-lock-open" },
    { label: "Map", iconClass: "fas fa-map" },
    { label: "Map Marker Alt", iconClass: "fas fa-map-marker-alt" },
    { label: "Minus", iconClass: "fas fa-minus" },
    { label: "Minus Circle", iconClass: "fas fa-minus-circle" },
    { label: "Paper Plane", iconClass: "fas fa-paper-plane" },
    { label: "Paperclip", iconClass: "fas fa-paperclip" },
    { label: "Paste", iconClass: "fas fa-paste" },
    { label: "Pen", iconClass: "fas fa-pen" },
    { label: "Pencil Alt", iconClass: "fas fa-pencil-alt" },
    { label: "Phone", iconClass: "fas fa-phone" },
    { label: "Play", iconClass: "fas fa-play" },
    { label: "Plus", iconClass: "fas fa-plus" },
    { label: "Plus Circle", iconClass: "fas fa-plus-circle" },
    { label: "Print", iconClass: "fas fa-print" },
    { label: "Question Circle", iconClass: "fas fa-question-circle" },
    { label: "Recycle", iconClass: "fas fa-recycle" },
    { label: "Redo", iconClass: "fas fa-redo" },
    { label: "Reply", iconClass: "fas fa-reply" },
    { label: "Rocket", iconClass: "fas fa-rocket" },
    { label: "Save", iconClass: "fas fa-save" },
    { label: "Search", iconClass: "fas fa-search" },
    { label: "Share", iconClass: "fas fa-share" },
    { label: "Shield Alt", iconClass: "fas fa-shield-alt" },
    { label: "Shopping Cart", iconClass: "fas fa-shopping-cart" },
    { label: "Sign Out Alt", iconClass: "fas fa-sign-out-alt" },
    { label: "Spinner", iconClass: "fas fa-spinner" },
    { label: "Stop", iconClass: "fas fa-stop" },
    { label: "Sync", iconClass: "fas fa-sync" },
    { label: "Table", iconClass: "fas fa-table" },
    { label: "Tag", iconClass: "fas fa-tag" },
    { label: "Tasks", iconClass: "fas fa-tasks" },
    { label: "Thumbs Up", iconClass: "fas fa-thumbs-up" },
    { label: "Times", iconClass: "fas fa-times" },
    { label: "Trash", iconClass: "fas fa-trash" },
    { label: "Undo", iconClass: "fas fa-undo" },
    { label: "Unlock", iconClass: "fas fa-unlock" },
    { label: "Upload", iconClass: "fas fa-upload" },
    { label: "User", iconClass: "fas fa-user" },
    { label: "User Circle", iconClass: "fas fa-user-circle" },
    { label: "User Friends", iconClass: "fas fa-user-friends" },
    { label: "Users", iconClass: "fas fa-users" },
    { label: "Video", iconClass: "fas fa-video" },
    { label: "Volume Up", iconClass: "fas fa-volume-up" },
    { label: "Wallet", iconClass: "fas fa-wallet" },
    { label: "Wrench", iconClass: "fas fa-wrench" },
    // Agrega más según necesites...
  ];
  